import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { IsIcorStudyActiveQuery, IsIcorStudyActiveQueryVariables } from '@/shared/api';
import IS_ICOR_STUDY_ACTIVE_QUERY from '../queries/isIcorStudyActive';

/**
 * Checks whether an ICOR device already has an active study. Runs the isIcorStudyActive query for the device id and throws the first GraphQL error only when the flag is missing.
 *
 * @param deviceId - Identifier of the ICOR device to check.
 * @returns A promise resolving to the active-study indicator.
 */
const fetchIsIcorStudyActive = async (deviceId: any) => {
  const client = createClient();
  const result = await client.query<IsIcorStudyActiveQuery, IsIcorStudyActiveQueryVariables>({
    query: IS_ICOR_STUDY_ACTIVE_QUERY,
    variables: {
      deviceId,
    },
  });
  const { data, errors } = result;
  const { isIcorStudyActive } = data;
  if (_.isNil(isIcorStudyActive) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return isIcorStudyActive;
};

export default fetchIsIcorStudyActive;
